import React, { useState } from "react";
import MyModal from "../UI/modal/MyModal";
import EventModal from "./EventModal";

const Event = function ({ children, event, eventChangingCallback, legendsMap, ...props }) {
    const [modal, setModal] = useState(false);
    const modalChange = function () {
        setModal(!modal);
    }

    return (
        <div {...props} className={"forecast "+event.code} onClick={() => modalChange()}>
            <MyModal
                visible={modal}
                setVisible={setModal}
                style={{ width: "50%" }}
            >
                <EventModal event={event} legendsMap={legendsMap} eventChangingCallback={eventChangingCallback} closeModalCallback={setModal} actionMethod={"PUT"}/>
            </MyModal>
            <span>
                {legendsMap.get(event.code)} - {event.start.substring(0, 19).replace('T', ' ')} {event.finish.substring(0, 19).replace('T', ' ')}
            </span>
            {children}
        </div>
    );
}
export default Event;